import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { get } from 'lodash';

import { CURRENCIES_SYMBOLS_BY_ISO_CODE } from 'projects/workspace/src/app/accounting/accounting.constants';
import { AppState } from '../../../store/state/app.state';
import { selectScheduledPayment } from '../../store/selectors';
import { PriceInfoModel, ScheduledPaymentModel, ScheduledPaymentPositionTotalsModel } from '../../models';
// import { PartnersTypeEnum } from '../../../partners/corporate/enums';


@Component({
  selector: 'rnpl-scheduled-payment-summary',
  templateUrl: './scheduled-payment-summary.component.html',
})
export class ScheduledPaymentSummaryComponent implements OnInit, OnDestroy {

  @Input() workspaceCurrency: string = 'EUR';
  public scheduledPayment: ScheduledPaymentModel;
  public currenciesSymbols = CURRENCIES_SYMBOLS_BY_ISO_CODE;

  public readonly destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(private readonly store: Store<AppState>) {
  }

  ngOnInit(): void {
    this.trackScheduledPaymentChanges();
  }

  private trackScheduledPaymentChanges(): void {
    this.store.select(selectScheduledPayment)
      .pipe(takeUntil(this.destroy$))
      .subscribe((scheduledPayment: ScheduledPaymentModel) => this.scheduledPayment = scheduledPayment);
  }

  public get documentCurrencySymbol(): string {
    return this.currenciesSymbols[get(this.scheduledPayment, 'properties.currency', this.workspaceCurrency)];
  }

  public get workspaceCurrencySymbol(): string {
    return this.currenciesSymbols[this.workspaceCurrency];
  }

  get documentSummary(): PriceInfoModel {
    return this.scheduledPayment.summary.document;
  }

  get localSummary(): PriceInfoModel {
    return this.scheduledPayment.summary.local;
  }

  get positionTotals(): ScheduledPaymentPositionTotalsModel {
    return this.scheduledPayment.positionTotals;
  }

  // get isPrivatePartner(): boolean {
  //   return get(this, 'scheduledPayment.properties.partnerProfile.type') === PartnersTypeEnum.PRIVATE;
  // }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

}
